<template>
  <div
    class="grouping-container"
    :class="{ official: tabIndex === 2 }"
    :style="{ height: tabIndex === 2 ? officialHeight + 'px' : 'auto' }"
  >
    <template v-if="groupingShow">
      <header class="head">
        <h4>客户分群</h4>
        <div class="tab-line">
          <div
            class="tab-item"
            @click="handleSwitch(1)"
            :class="{ active: tabIndex == '1' }"
            :style="{
            color: tabIndex == '1' ? globalBG : '',
            'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
          }"
          >
            人群列表
            <span></span>
          </div>
          <!-- 2期 -->
          <div
            class="tab-item"
            v-if="shopCategoryVisiv"
            @click="handleSwitch(4)"
            :class="{ active: tabIndex == '4' }"
            :style="{
              color: tabIndex == '4' ? globalBG : '',
              'border-top': tabIndex == '4' ? '2px solid ' + globalBG : '',
            }"
          >
            行业专属人群
            <span></span>
          </div>
          <!-- end -->
          <div
            class="tab-item"
            @click="handleSwitch(3)"
            :class="{ active: tabIndex == '3' }"
            :style="{
            color: tabIndex == '3' ? globalBG : '',
            'border-top': tabIndex == '3' ? '2px solid ' + globalBG : '',
          }"
          >
            系统推荐人群
            <span></span>
          </div>
          <div
            class="tab-item"
            @click="handleSwitch(2)"
            :class="{ active: tabIndex == '2' }"
            :style="{
            color: tabIndex == '2' ? globalBG : '',
            'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
          }"
          >
            官方推荐人群
            <span></span>
          </div>
          <!-- 2期 -->
          <div
            class="tab-item"
            v-if="permissionsList.indexOf('hide:customCrowd') > -1"
            @click="handleSwitch(5)"
            :class="{ active: tabIndex == '5' }"
            :style="{
              color: tabIndex == '5' ? globalBG : '',
              'border-top': tabIndex == '5' ? '2px solid ' + globalBG : '',
            }"
          >
            定制人群
            <span></span>
          </div>
          <div
            class="tab-item"
            @click="handleSwitch(6)"
            :class="{ active: tabIndex == '6' }"
            :style="{
            color: tabIndex == '6' ? globalBG : '',
            'border-top': tabIndex == '6' ? '2px solid ' + globalBG : '',
          }"
          >
            人群运算
            <span></span>
          </div>
          <div
            class="tab-item"
            @click="handleSwitch(7)"
            :class="{ active: tabIndex == '7' }"
            :style="{
            color: tabIndex == '7' ? globalBG : '',
            'border-top': tabIndex == '7' ? '2px solid ' + globalBG : '',
          }"
          >
            官方人群
            <span></span>
          </div>
          <!-- end -->
        </div>
        <div class="head-cnt">
          <!-- 提示 -->
          <div class="tips" v-if="tabIndex != 3 && tabIndex != 4 && tabIndex != 5 && tabIndex != 6">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="display: inline-block;float: left;position: relative;width: 14px;height: 14px;color: #ffffff;margin: 0px -18px 0 0px;"
            >
            <div class="area" style="margin-left: 24px" v-if="tabIndex === 1">
              <span>温馨提示</span>
              <p>
                1.此功能为京东官方功能，必须报备店铺签名后才可以筛选出数据，营销效果分析需要第二天才可以查看!
                <span
                  class="set"
                  style="color: #7f85e9"
                  v-zoom="{ from: pageName, name: '去设置' }"
                  @click="setDialogVisible = true"
                >去设置</span>
              </p>
              <span
                style="margin-bottom: 4px"
              >2. 官方规定：每个商家的人群策略最多创建{{ peopleNumState }}个（不包含系统人群），若您的策略已到达上限，请先删除一些无用分组，再进行人群创建。</span>
              <!-- <span style="line-height: 20px"
                >2.
                京东官方短信频控规则：同一商家2天内给同一手机号发送营销短信条数不超过1条；每个手机号每
                1 天只能收到 3 条京东商家短信，每 2 天只能收到 5
                条京东商家短信</span
              >-->
            </div>
            <div class="area" style="margin-left: 24px" v-if="tabIndex === 2">
              <span>使用说明</span>
              <p>1.依赖于官方智能算法，每天为商家提供大中小三个转化率高的人群标签策略包。若策略人数大于100，可一键转化为人群或直接营销，小于100无法营销；</p>
              <span
                style="margin-bottom: 4px"
              >2.人群策略每天都会更新，为保证使用效果，建议当天使用。该功能目前只有部分类目开放，若无人群包则目前该类目尚不支持官方推荐的人群包；</span>
            </div>
            <div class="area" style="margin-left: 24px" v-if="tabIndex === 7">
              <span>人群说明：以下人群策略源于官方，可直接进行营销，数坊侧策略人群数量小于20时无法营销。人群策略每天凌晨自动更新，可点击右侧按钮进行手动更新。</span>
            </div>
          </div>
          <!-- 官方人群推荐 -->
          <ul class="tempList official" v-if="tabIndex === 2">
            <template v-for="(item, index) in officialList">
              <li class="item-box" :key="index">
                <div class="item">
                  <div class="headName">
                    <img class="i" src="../../assets/images/systemIcon.png" alt>
                    <el-tooltip
                      v-if="item.strategyName.length > 13"
                      effect="light"
                      :content="item.strategyName"
                      placement="bottom"
                    >
                      <span class="name">{{ item.strategyName }}</span>
                    </el-tooltip>
                    <span class="name" v-if="item.strategyName.length <= 13">{{ item.strategyName }}</span>
                  </div>
                  <el-popover
                    v-if="item.searchQueryDesc.length > 15"
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    :content="item.searchQueryDesc"
                  >
                    <p class="desc" slot="reference">{{ item.searchQueryDesc }}</p>
                  </el-popover>
                  <p
                    class="desc"
                    v-if="item.searchQueryDesc.length <= 15"
                  >{{ item.searchQueryDesc }}</p>
                  <div class="footBtn">
                    <p>
                      {{ item.userNum }}
                      <span>人</span>
                    </p>
                    <div class="btns">
                      <el-button class="yinxiao_button2" @click="handleOfficalMarket(item)">立即营销</el-button>
                    </div>
                  </div>
                </div>
              </li>
            </template>
          </ul>
          <div class="no-goods" v-if="tabIndex === 2 && officialList.length === 0">
            <img src="@/assets/images/default/no_goods.png" alt>
            <p>没有官方人群推荐哦~</p>
          </div>
          <!-- 系统推荐人群 -->
          <template v-if="tabIndex === 1">
            <div class="systemDesc" style="position:relative">
              <p style="align-items:flex-start;flex-flow:row wrap;max-width:93%;display:inline">
                <span class="system" v-if="systemData.length > 0">{{ systemData[0].classifyName }}</span>
                <span
                  class="update"
                  v-if="systemData.length > 0"
                  style="color:#666;line-height:20px"
                >
                  {{
                  systemData[0].classifyDescription }}
                </span>
              </p>
              <span
                class="open"
                @click="handleSwitchJump(sysTypeLink)"
                style="width:90px;position:absolute;right:0px;top:7px"
              >查看更多>></span>
              <!-- <span class="open" v-else @click="openSystem = false">收起</span> -->
            </div>
            <!-- 推荐模块 -->
            <ul
              class="tempList"
              style="max-height:200px"
              :class="openSystem ? 'check' : ''"
              v-loading="loadingTableOne"
            >
              <template v-for="item in systemData">
                <li class="item-box" v-if="item.isHide" :key="item.precisionCrowdStrategyId">
                  <div class="item">
                    <img class="imgpath" v-if="item.iconPath" :src="item.iconPath" alt>
                    <div class="headName">
                      <img class="i" src="../../assets/images/systemIcon.png" alt>
                      <el-tooltip
                        v-if="item.name.length > 12"
                        effect="light"
                        :content="item.name"
                        placement="bottom"
                      >
                        <span class="name">{{ item.name }}</span>
                      </el-tooltip>
                      <div class="wrap-name">
                        <span class="name" v-if="item.name.length <= 12">{{ item.name }}</span>
                        <img v-if="item.logoType === 1" src="@/assets/images/tag_hot.png" alt>
                        <img v-if="item.logoType === 2" src="@/assets/images/tag_new.png" alt>
                      </div>
                    </div>
                    <el-popover
                      v-if="item.description.length > 15"
                      placement="top-start"
                      width="200"
                      trigger="hover"
                      :content="item.description"
                    >
                      <p class="desc" slot="reference">{{ item.description }}</p>
                    </el-popover>
                    <p class="desc" v-if="item.description.length <= 15">{{ item.description }}</p>
                    <!-- 2期  -->
                    <div v-if="item.isAdvanced" style="padding-bottom:20px">
                      <span style="color:#333;">高级版专属</span>
                      <span style="float:right;color:#fe4d45;cursor:pointer" @click="upgrade">点击升级>></span>
                    </div>

                    <!-- end -->
                    <!-- <p class="desc" v-if="item.description.length<=10">{{ item.description }}</p> -->
                    <div class="footBtn" v-else>
                      <p>
                        {{ item.count }}
                        <span>人</span>
                      </p>
                      <div class="btns">
                        <el-button
                          class="yinxiao_button4"
                          v-if="(item.type == 0 || item.type == 1) && item.count != 0"
                          @click="handleAnalysis(item)"
                        >人群分析</el-button>
                        <el-button v-else class="yinxiao_button3">人群分析</el-button>
                        <el-button
                          v-zoom="{ from: pageName, name: '立即营销' }"
                          v-show="item.count != 0"
                          class="yinxiao_button2"
                          @click="goToMarketing(item)"
                        >立即营销</el-button>
                        <el-button v-show="item.count == 0" class="yinxiao_button3">立即营销</el-button>
                      </div>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </template>
          <!-- 推荐模块 -->
          <template v-if="tabIndex === 3 || tabIndex === 4 || tabIndex === 5 || tabIndex === 7">
            <div>
              <p>
                <span
                  class="update"
                  v-if="(isOpenFlag != 0 && tabIndex == 4) || (isOpenFlagOne != 0 && tabIndex == 5) || tabIndex == 3"
                >
                  数据更新时间：{{
                  this.currentdate }}
                </span>
                <span style="float:right;margin-right:20px" v-if="tabIndex !== 3 && tabIndex !== 7">
                  <el-tooltip :content="iconConent" placement="top" effect="light">
                    <i class="el-icon-question" style="color:#fe4d45"></i>
                  </el-tooltip>人群获取
                  <el-switch
                    v-if="tabIndex == 4"
                    :active-value="1"
                    :inactive-value="0"
                    v-model="isOpenFlag"
                    @change="changeSwitch(isOpenFlag)"
                  ></el-switch>
                  <el-switch
                    v-if="tabIndex == 5"
                    :active-value="1"
                    :inactive-value="0"
                    v-model="isOpenFlagOne"
                    @change="changeSwitchOne(isOpenFlagOne)"
                  ></el-switch>
                </span>
                <span v-if="tabIndex == 7" style="display: flex; flex-direction: row; justify-content: space-between;align-items: center; margin: 15px 0;">
                  <span>数据更新时间：{{ this.currentdate }}</span>
                  <el-button type="text" @click="updateCrowdStrategy">更新人群策略</el-button>
                </span>
              </p>
            </div>
            <div v-loading="loadingTable">
              <div
                v-if="(isOpenFlag == 0 && tabIndex == 4) || (isOpenFlagOne == 0 && tabIndex == 5)"
                style="padding:100px;text-align:center"
              >
                <div>
                  <img style="width:200px;height:200px" src="../../assets/images/定制人群获取关闭.svg">
                </div>
                <span style="color:#999999">{{ meaasgeClose }}</span>
              </div>
              <!-- 官方人群空提示 -->
              <div v-if="officialListitem.length == 0 && tabIndex == 7"
                  style="padding:100px;text-align:center">
                  <div>
                    <img src="@/assets/images/default/no_goods.png" alt>
                  </div>
                  <span style="color:#999999">暂时还没有人群哦~</span>
                </div>
              <ul
                v-if="(isOpenFlag != 0 && tabIndex == 4) || (isOpenFlagOne != 0 && tabIndex == 5) || tabIndex == 3 || tabIndex == 7"
              >
                <template v-for="(item, index) in officialListitem">
                  <div class="classifyName systems" :key="index + '@'">
                    <div>
                      <span style="line-height:24px">{{ item.classifyName }}</span>
                      <span style="padding-left:8px;font-size: 12px;color:#666;line-height:20px">
                        {{
                        item.classifyDescription }}
                      </span>
                    </div>
                    <span
                      class="open"
                      @click="handleOpenSystem(index)"
                      v-show="item.list.length >= 5"
                    >
                      {{ item.openSystem
                      ? "展开" : "收起" }}
                    </span>
                  </div>
                  <div class="tempList" :key="index + '?'" :style="{'justify-content': item.list.length == 0 ? 'center': ''}">
                    <div style="padding:100px;text-align:center" v-if="item.list.length === 0">
                      <span style="color:#999999">暂时还没有人群哦~</span>
                    </div>
                    <template v-for="info in item.list">
                      <li class="item-box" v-if="info.isHide" :key="info.precisionCrowdStrategyId">
                        <div class="item">
                          <img class="imgpath" v-if="info.iconPath" :src="info.iconPath" alt>
                          <div class="headName">
                            <img class="i" src="../../assets/images/systemIcon.png" alt>
                            <el-tooltip
                              v-if="info.name.length > 12"
                              effect="light"
                              :content="info.name"
                              placement="bottom"
                            >
                              <span class="name">{{ info.name }}</span>
                            </el-tooltip>
                            <div class="wrap-name">
                              <span class="name" v-if="info.name.length <= 12">{{ info.name }}</span>
                              <img v-if="info.logoType === 1" src="@/assets/images/tag_hot.png" alt>
                              <img v-if="info.logoType === 2" src="@/assets/images/tag_new.png" alt>
                            </div>
                          </div>
                          <el-popover
                            v-if="info.description.length > 15"
                            placement="top-start"
                            width="200"
                            trigger="hover"
                            :content="info.description"
                          >
                            <p class="desc" slot="reference">{{ info.description }}</p>
                          </el-popover>
                          <p
                            class="desc"
                            v-if="info.description.length <= 15"
                          >{{ info.description }}</p>
                          <!-- 2期  -->
                          <div v-if="info.isAdvanced" style="padding-bottom:20px">
                            <span style="color:#333;">高级版专属</span>
                            <span
                              style="float:right;color:#fe4d45;cursor:pointer"
                              @click="upgrade"
                            >点击升级>></span>
                          </div>
                          <!-- end -->
                          <!-- <p class="desc" v-if="item.description.length<=10">{{ item.description }}</p> -->
                          <div class="footBtn" v-if="!info.isAdvanced">
                            <p>
                              {{ info.count }}
                              <span>人</span>
                            </p>
                            <div class="btns">
                              <template v-if="tabIndex != 7">
                                <el-button
                                  class="yinxiao_button4"
                                  v-if="(info.type == 0 || info.type == 1) && info.count != 0"
                                  @click="handleAnalysis(info)"
                                >人群分析</el-button>
                                <el-button v-else class="yinxiao_button3">人群分析</el-button>
                              </template>
                              <el-button
                                v-zoom="{ from: pageName, name: '立即营销' }"
                                v-if="(info.count != 0 && tabIndex != 7)
                                || (info.count > 20 && tabIndex == 7 && item.type > 1)
                                || (info.count != 0 && tabIndex == 7 && item.type == 1)"
                                class="yinxiao_button2"
                                @click="goToMarketing(info)"
                              >立即营销</el-button>
                              <el-button v-else class="yinxiao_button3">立即营销</el-button>
                            </div>
                          </div>
                        </div>
                      </li>
                    </template>
                  </div>
                </template>
              </ul>
            </div>
          </template>
          <!-- 计算人群 -->
          <template v-if="tabIndex === 6">
            <inputForm @onSerach="onSerach"/>
          </template>
        </div>
      </header>
      <!-- 底部表格 -->
      <footer v-if="tabIndex === 1" class="footTable">
        <div class="systemDesc">
          <p>
            <span class="system">我的人群库</span>
            <span class="update" style="color:#666666">数据更新时间：{{ this.currentdate }}</span>
          </p>
        </div>
        <!-- 查询条件 -->
        <div class="scene">
          <div class="scene_label" style="width: 112px;">人群来源</div>
          <div class="scene_ul">
            <div class="scene_li" :class="{ scene_li_check: item.value === search.type }"
              v-for="(item, index) in peopleList" :key="index" @click="handleTypeClick(item.value)">{{ item.label }}
            </div>
          </div>
        </div>
        <div class="search" style="margin-top: 8px;">
          <ul class="right" style="margin-top: 10px">
            <li class="line">
              <span>人群信息：</span>
              <el-input placeholder="请输入人群名称/描述/ID" v-model="search.searchKey" style="margin-right: 12px"></el-input>
            </li>
            <li class="line" style="margin-right: 30px">
              <span>人群分类：</span>
              <el-cascader
                v-if="searchCrowdType != 0"
                style="width:320px"
                :popper-class="search.type === ''?'all-classify':''"
                v-model="classifyIdList"
                @change="classifyIdListChange"
                @expand-change="expandChange"
                :options="classPeopleList"
                :collapse-tags="true"
                :show-all-levels="false"
                :props="{ checkStrictly: search.type === ''?false:true,emitPath: search.type === ''?true:false, multiple: true, expandTrigger: 'hover', value: 'id',label: 'name' }"
              >
                <template slot-scope="{ node, data }">
                  <span>{{data.name}}</span>
                </template> 
              </el-cascader>
              <el-select v-model="search.classifyIds" v-else style="width:320px">
                <el-option value="" label="全部"></el-option>
              </el-select>
            </li>
            <!-- <li class="line">
              <span>人群描述：</span>
              <el-input placeholder="请输入人群描述..." v-model="search.description"></el-input>
            </li> -->
            <li class="btn">
              <button
                @click="getList"
                ref="focus"
                v-zoom="{ from: pageName, name: '查询列表' }"
                style="width: 98px"
              >
                <i
                  class="el-icon-search"
                  style="
                                                                                                            display: inline-block;
                                                                                                            width: 14px;
                                                                                                            height: 12px;
                                                                                                            margin-top: -10px;
                                                                                                    "
                ></i>
                查询
              </button>
              <button @click="reset" style="width: 98px">重置</button>
            </li>
          </ul>
        </div>
        <div class="search" style="margin: 20px 0">
          <div class="left">
            <button
              v-zoom="{ from: pageName, name: '创建人群' }"
              class="biaoqian_button"
              @click="labelCircle"
            >
              创建人群
              <span style="color: #fff">({{ count }}/{{peopleNumState}})</span>
            </button>
            <button
              class="biaoqian_button1"
              :disabled="synchLoading"
              v-loading="synchLoading"
              @click="handleSynch"
            >同步数坊人群</button>
            <el-button
              v-zoom="{ from: pageName, name: '上传人群' }"
              class="biaoqian_button2"
              style="margin-top: 10px"
              @click="dialogGenerate = true"
            >上传人群</el-button>
            <el-button
              class="biaoqian_button2"
              style="margin-top: 10px;margin-left: 0 !important;"
              :disabled="synchLoading"
              v-loading="synchLoading"
              @click="delPrecisionMember()"
            >批量删除</el-button>
            <el-button
              class="biaoqian_button2"
              style="margin-top: 10px;margin-left: 0 !important;"
              @click="handleCreateClassify"
            >管理分类</el-button>
            <el-button
              class="biaoqian_button2"
              style="margin-top: 10px;margin-left: 0 !important;"
              @click="dialogBuySku = true"
            >购买sku人群</el-button>
            <!-- <div>
              <span style="padding-top: 10px">{{ count }}/200</span>
            </div>-->
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          tooltip-effect="light"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
          @selection-change="handleSelectionChange2"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png">
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column type="selection" :selectable="selectable" align="center"></el-table-column>
          <el-table-column prop="name" label="人群名称" width="180px">
            <template slot-scope="scope">
              <img v-if="scope.row.logoType === 1" src="@/assets/images/tag_hot.png" alt>
              <img v-if="scope.row.logoType === 2" src="@/assets/images/tag_new.png" alt>
              <span
                v-if="scope.row.logoType == 1 || scope.row.logoType == 2"
                style="padding-left: 8px"
              >
                {{ scope.row.name
                }}
              </span>
              <span v-if="scope.row.logoType != 1 && scope.row.logoType != 2">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="人群类型" width="120px">
            <template slot-scope="scope">
              {{
              scope.row.type == 1 ? "自定义人群"
              : scope.row.type == 0
              ? "系统分组"
              : scope.row.type == 7
              ? "数坊人群"
              : scope.row.type == 8
              ? scope.row.isLabelCreated
              ? "上传人群(自定义标签)"
              : "上传人群"
              : scope.row.type == 9
              ? "官方推荐人群"
              : scope.row.type == 10
              ? "行业专属人群"
              : scope.row.type == 11
              ? "定制人群"
              : scope.row.type == 12
              ? "运算人群"
              : scope.row.type == 13
              ? "互动人群"
              : scope.row.type == 14
              ? "二次营销"
              : scope.row.type == 15
              ? "官方人群"
              : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="count" label="人群数量（人）" width="130px">
            <template
              slot-scope="scope"
            >{{ scope.row.isAdvanced && scope.row.count == 0 ? "--" : (scope.row.type==14&&scope.row.count == null) ? 0 + '（生成中...）' : scope.row.count }}</template>
          </el-table-column>
          <el-table-column prop="description" label="人群描述" min-width="200px"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170px"></el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="170px">
            <template slot-scope="scope">
              <div class="operation-btn">{{ currentdate }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="320px">
            <template slot-scope="scope">
              <!-- 2期 高级版本 -->
              <div class="operation-btn" v-if="!scope.row.isAdvanced">
                <el-button
                  type="text"
                  class="titleColorR"
                  style=" width: 70px;margin-left: 0;padding-left: 0 !important;"
                  v-if="(scope.row.type == 0 || scope.row.type == 1 || scope.row.type == 10 || scope.row.type == 11) && scope.row.count != 0 && scope.row.name.indexOf('官方推荐') === -1"
                  @click="handleAnalysis(scope.row)"
                  v-zoom="{ from: pageName, name: '人群分析' }"
                >人群分析</el-button>

                <el-button
                  type="text"
                  style="width: 70px;margin-left: 0;padding-left: 0 !important;"
                  class="titleColorB"
                  v-else
                >人群分析</el-button>
                <span class="titleColorB" v-if="(scope.row.type == 14&&(scope.row.count == null||scope.row.count == 0))||scope.row.count == 0">营销</span>
                <span
                  class="titleColorR"
                  v-zoom="{ from: pageName, name: '营销' }"
                  @click="goToMarketing(scope.row)"
                  v-else
                >营销</span>
                <span
                  class="titleColorB"
                  v-if="(scope.row.type == 8 && scope.row.isLabelCreated) || scope.row.type == 0 || scope.row.type == 7 || scope.row.type == 9 || scope.row.type == 10 || scope.row.type == 11 || scope.row.type == 12 || scope.row.type == 14 || scope.row.type == 15 || scope.row.name.indexOf('官方推荐') !== -1 || scope.row.labelBuildType == 1"
                >编辑</span>
                <span
                  class="titleColorR"
                  v-else-if="scope.row.type != 0"
                  @click="handleEdit(scope.row)"
                  v-zoom="{ from: pageName, name: '编辑' }"
                >编辑</span>
                <span
                  class="titleColorB"
                  v-if="scope.row.type == 0 || scope.row.type == 10 || scope.row.type == 11 || scope.row.type == 15"
                >删除</span>
                <span
                  class="titleColorR"
                  v-else-if="scope.row.type != 0"
                  @click="handleDelete1(scope.row)"
                  v-zoom="{ from: pageName, name: '删除' }"
                >删除</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  v-if="scope.row.lastSynDmpStatus === false"
                  content="DMP同步中"
                  placement="top"
                >
                  <span class="titleColorB">同步数坊/DMP</span>
                </el-tooltip>
                <span v-else-if="(scope.row.type==14&&(scope.row.count==null||scope.row.count==0))||scope.row.count === 0" class="titleColorB">同步数坊/DMP</span>
                <template v-else>
                  <el-tooltip
                    class="item"
                    v-if="scope.row.lastSynDmpTime"
                    effect="light"
                    :key="scope.$index"
                    :content="'上次同步应用：'+ getSynData(scope.row) + '；上次同步时间' + scope.row.lastSynDmpTime"
                    placement="top"
                  >
                    <div slot="content">上次同步应用：{{ getSynData(scope.row) }}<br/>上次同步时间： {{ scope.row.lastSynDmpTime }}</div>
                    <span
                      class="titleColorR"
                      v-zoom="{ from: pageName, name: '同步数坊/DMP' }"
                      @click="handleSynDMP(scope.row)"
                    >同步数坊/DMP</span>
                  </el-tooltip>
                  <span
                    v-else
                    class="titleColorR"
                    v-zoom="{ from: pageName, name: '同步数坊/DMP' }"
                    @click="handleSynDMP(scope.row)"
                  >同步数坊/DMP</span>
                </template>
                <span
                  class="titleColorR"
                  v-if="(scope.row.type == 1 || scope.row.type == 13) && scope.row.name.indexOf('官方推荐') === -1 && scope.row.labelBuildType != 1"
                  v-zoom="{ from: pageName, name: '复制' }"
                  @click="handleCopy(scope.row)"
                >复制</span>
                <span class="titleColorB" v-else>复制</span>

                <!-- <el-button
                  type="text"
                  v-if="scope.row.count <= 0"
                  style="color: #ddd"
                  >营销</el-button
                >
                <el-button type="text" @click="goToMarketing(scope.row)" v-else
                  >营销</el-button
                >
                <el-button
                  v-if="scope.row.type == 0 || scope.row.type == 7"
                  type="text"
                  style="color: #ddd"
                  >编辑</el-button
                >
                <el-button
                  v-else-if="scope.row.type != 0"
                  type="text"
                  @click="handleEdit(scope.row)"
                  >编辑</el-button
                >-->
                <!-- <el-button
                  v-if="scope.row.type == 0 || scope.row.type == 7"
                  type="text"
                  style="color: #ddd"
                  >删除</el-button
                >
                <el-button
                  v-else-if="scope.row.type != 0"
                  type="text"
                  @click="handleDelete1(scope.row)"
                  >删除</el-button
                >-->
              </div>
              <div v-else>
                高级版专属人群
                <el-button type="text" @click="upgrade">点击立即升级>></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="search.size"
          :current-page="search.current"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </footer>
      <div v-if="tabIndex === 6" class="footTable">
        <div class="search" style="margin-bottom: 20px;margin-top: -10px;">
          <div class="left">
            <button class="biaoqian_button" @click="newPrecisionTask">新建人群运算任务</button>
            <button
              class="biaoqian_button1"
              :disabled="synchLoading"
              v-loading="synchLoading"
              @click="delPrecisionTask(1)"
            >批量删除</button>
            <span style="color: red;position: relative;top: 8px;left: 10px;">*运算完成后的人群包会展示在客户分群列表中</span>
          </div>
        </div>
        <!-- 表格 -->
        <el-table
          v-loading="tableLoading"
          :data="crowdTaskData"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png">
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <!-- v-if="showsss" -->
          <el-table-column type="selection" width="55" :selectable="checkboxT"></el-table-column>

          <el-table-column prop="taskName" label="任务名称"></el-table-column>
          <el-table-column prop="crowName" label="人群名称"></el-table-column>
          <el-table-column
            key="crowName"
            label="人群描述"
            min-width="120px"
            prop="crowName"
            width="150"
          >
            <template slot="header" slot-scope="scope">
              <span>人群描述</span>
              <span
                v-if="!allShow"
                :style="{ color: globalBG, cursor: 'pointer' }"
                @click="allShow = true"
                class="table-message"
              >(展开全部)</span>
              <span
                v-if="allShow"
                :style="{ color: globalBG, cursor: 'pointer' }"
                @click="allShow = false"
                class="table-message"
              >(单行显示)</span>
            </template>
            <template slot-scope="scope">
              <div>
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="scope.row.crowName"
                  placement="top"
                >
                  <div class="hoveTitle" v-show="!allShow">{{ scope.row.crowName }}</div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow">{{ scope.row.crowName }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column prop="type" label="操作方式" width="150">
            <template slot-scope="scope">
              <span>{{ scope.row.type == 1 ? "人群交并差" : "人群抽取" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="计算进度">
            <template slot-scope="scope">
              <el-progress
                :percentage="100"
                color="#f56c6c"
                status="exception"
                v-if="scope.row.status == 2"
              ></el-progress>
              <el-progress :percentage="100" status="success" v-if="scope.row.status == 1"></el-progress>
              <el-progress
                :percentage="Number(scope.row.percent.split('%')[0]) || 0"
                color="#7f85e9"
                v-if="scope.row.status == 0"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="运算进程" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">计算中</span>
              <span v-if="scope.row.status == 1">已完成</span>
              <span v-if="scope.row.status == 2">已失败</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="操作" width="120px">
            <template slot-scope="scope">
              <div class="operation-btn">
                <span
                  :class="scope.row.status == 0 ? 'titleColorB' : 'titleColorR'"
                  @click="delPrecisionTask(2, scope.row)"
                >删除</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="searchTask.size"
          :current-page="searchTask.current"
          layout="total, sizes, prev, pager, next, jumper"
          :total="searchTaskTotal"
          class="pagination"
        ></el-pagination>
      </div>
    </template>

    <!-- 人群分析 -->
    <analysis
      v-if="analysisIsShow"
      @back="analysisBack"
      :sellerList="sellerList"
      :show="analysisIsShow"
      :crowdArray="crowdArray"
    ></analysis>
    <!-- 人群筛选 -->
    <!-- <people-filter @on-cancel="onCancel" :editData="editData" :visible="peopleFilter"></people-filter> -->
    <!-- 去设置弹层 -->
    <SetDialog :visible="setDialogVisible" @close="setDialogVisible = false"></SetDialog>
    <!-- 删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="outerVisible"
      width="400px"
      :before-close="closehandleDelete"
    >
      <img
        src="@/assets/images/tips_icon.png"
        class="tips"
        style="
                                                                                                  margin: 6px 0px 0px 110px;
                                                                                                  position: absolute;
                                                                                                  width: 22px;
                                                                                                  height: 22px;
                                                                                                "
      >
      <span style="position: absolute; margin: 10px 0px 0px 140px; font-size: 14px">确定要删除吗?</span>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTable">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 删除弹框 -->
    <el-dialog
      title="提示"
      :visible.sync="delTaskDialog"
      width="400px"
      :before-close="closehandleDelete1"
    >
      <div v-if="delMessage == 2">
        <img
          src="@/assets/images/tips_icon.png"
          style="margin: 6px 0px 0px 30px;position: absolute;width: 20px;"
        >
        <p
          style="position: absolute; margin: 0px 0px 0px 60px; font-size: 14px;width: 290px;line-height: 20px;"
        >
          本次操作仅删除该条运算记录,删除后
          <span style="color: red;">不可恢复</span>,是否继续?
        </p>
      </div>
      <div v-else>
        <img
          src="@/assets/images/tips_icon.png"
          style="margin: 6px 0px 0px 50px;position: absolute;width: 20px;"
        >
        <span style="position: absolute; margin: 10px 0px 0px 80px; font-size: 14px">批量删除后不可恢复,是否继续?</span>
      </div>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete1">取 消</el-button>
        <el-button class="b2" @click="handleDeleteTask">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="synchDialog" width="400px">
      <div>
        <img
          src="@/assets/images/tips_icon.png"
          style="margin: 6px 0px 0px 30px;position: absolute;width: 20px;"
        >
        <p
          style="position: absolute; margin: 6px 0px 0px 60px; font-size: 14px;width: 290px;line-height: 20px;"
        >是否需要同步数坊人群？</p>
        <p
          style="position: absolute;color: #f59a23; font-size: 12px; margin-top: 30px; margin-left: 54px;"
        >（系统默认同步近30天推送成功的数坊人群）</p>
      </div>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="synchDialog = false">取 消</el-button>
        <el-button class="b2" @click="handleSynch">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="delMemberDialog"
      width="400px"
      :before-close="closehandleDelete1"
    >
      <div>
        <img
          src="@/assets/images/tips_icon.png"
          style="margin: 6px 0px 0px 30px;position: absolute;width: 20px;"
        >
        <p
          style="position: absolute; margin: 6px 0px 0px 60px; font-size: 14px;width: 290px;line-height: 20px;"
        >已选择{{delList2.length}}条数据，是否确定删除？</p>
      </div>
      <span slot="footer" class="buttonBox">
        <el-button class="b1" @click="closehandleDelete2">取 消</el-button>
        <el-button class="b2" @click="handleDeleteMember">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="上传人群"
      :before-close="closehandleSc"
      :visible.sync="dialogGenerate"
      width="640px"
    >
    <el-form :model="generateForm" label-width="100px" style="padding: 0 40px 0 0">
        <el-form-item label="人群名称:" required>
          <el-input v-model="generateForm.name"></el-input>
        </el-form-item>
        <el-form-item label="人群描述:" required>
          <el-input v-model="generateForm.description"></el-input>
        </el-form-item>
        <el-form-item label="上传类型:" required>
          <el-radio-group v-model="generateForm.uploadWay" @change="uploadWayChange">
            <el-radio :label="0">用户pin</el-radio>
            <el-radio :label="1">订单号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上传方式:" required v-if="generateForm.uploadWay == 0">
          <el-radio-group v-model="generateForm.uploadType">
            <el-radio :label="0">输入用户pin</el-radio>
            <el-radio :label="1">上传用户pin</el-radio>
          </el-radio-group>
          <div v-if="generateForm.uploadType == 0" style="margin-top: 20px">
            <el-input
              type="textarea"
              v-model="generateForm.pins"
              :autosize="{ minRows: 4, maxRows: 6 }"
            ></el-input>
            <div class="tips">
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  position: absolute;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 8px 4px 0 0;
                  ">
              <div class="area" style="margin-left: 22px">
                <p>1.每行一个用户pin;</p>
                <p>2.手动输入，一次输入最多支持2000行;</p>
                <p>3.上传人群中系统只会识别已购会员、品牌会员、0元开卡会员，其他维度的用户PIN会被去除。</p>
              </div>
            </div>
          </div>
          <div v-else style="margin-top: 20px">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :on-change="handleChange"
              :file-list="fileList"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :data="{
                name: generateForm.name,
                description: generateForm.description,
                uploadType: 1,
              }"
              accept=".txt"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传txt文件，且不超过20M</div>
            </el-upload>
            <el-progress
              :percentage="percentage"
              :format="format"
              :color="customColors"
              v-if="isShow"
            ></el-progress>
            <div class="tips">
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  position: absolute;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 8px 4px 0 0;
                "
              >
              <div class="area" style="margin-left: 22px">
                <p>
                  1.目前只支持上传TXT格式文件，单次上传最大20M;
                  <el-button
                    type="text"
                    style="margin-left: 20px; width: 60px"
                    @click="downloadTemplate"
                  >下载模板</el-button>
                </p>
                <p>2.每行一个用户pin;</p>
                <p>3.上传人群中系统只会识别已购会员、品牌会员、0元开卡会员，其他维度的用户PIN会被去除。</p>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上传方式:" required v-else>
          <el-radio-group v-model="generateForm.uploadType">
            <el-radio :label="0">输入订单号</el-radio>
            <el-radio :label="1">上传订单号</el-radio>
          </el-radio-group>
          <div v-if="generateForm.uploadType == 0" style="margin-top: 20px">
            <el-input
              type="textarea"
              v-model="generateForm.orderIds"
              :autosize="{ minRows: 4, maxRows: 6 }"
            ></el-input>
            <div class="tips">
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  position: absolute;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 8px 4px 0 0;
                  ">
              <div class="area" style="margin-left: 22px">
                <p>1.每行一个订单号;</p>
                <p>2.手动输入，一次输入最多支持2000行;</p>
              </div>
            </div>
          </div>
          <div v-else style="margin-top: 20px">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :on-change="handleChange"
              :file-list="fileList"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :data="{
                name: generateForm.name,
                description: generateForm.description,
                uploadType: 1,
              }"
              accept=".txt,.xls,.xlsx"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">支持上传txt、xls和xlsx格式文件，且不超过20M</div>
            </el-upload>
            <el-progress
              :percentage="percentage"
              :format="format"
              :color="customColors"
              v-if="isShow"
            ></el-progress>
            <div class="tips">
              <img
                src="@/assets/images/new_icon_reminder.png"
                style="
                  display: inline-block;
                  float: left;
                  position: absolute;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 8px 4px 0 0;
                "
              >
              <div class="area" style="margin-left: 22px">
                <p>
                  1.目前仅支持下载txt、xls 和.xlsx文件，单次上传最大20M;
                  <el-button
                    type="text"
                    @click="downloadTemplate2"
                  >下载txt模板</el-button>
                  <el-button
                    type="text"
                    style="margin-left: 20px;"
                    @click="downloadTemplate3"
                  >下载excel模板</el-button>
                </p>
                <p>2.每行一个订单号;</p>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -20px">
        <el-button @click="dialogGenerate = false" style="border: 1px solid #ddd">取 消</el-button>
        <el-button type="primary" @click="generateCrowd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog
      :title="classifyForm.id ? '修改分类':'创建分类'"
      
      :visible.sync="classifyVisible"
      width="500px"
    >
      <el-form :model="classifyForm" label-width="100px" style="padding: 0 40px 0 0">
        <el-form-item label="一级分类:" required>
          <el-select v-model="classifyForm.type" style="width:100%" :disabled="!!this.classifyForm.id">
            <el-option label="自定义人群" :value="1"></el-option>
            <el-option label="运算人群" :value="12"></el-option>
            <el-option label="互动人群" :value="13"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称:" required>
          <el-input v-model="classifyForm.name" maxlength="15" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-top: -20px">
        <el-button @click="classifyVisible = false" style="border: 1px solid #ddd">取 消</el-button>
        <el-button type="primary" @click="saveClassify">确 定</el-button>
      </div>
    </el-dialog> -->
    <!-- 管理分类 -->
    <myClassify v-if="classifyVisible" :visible="classifyVisible" @close="classifyVisible = false"></myClassify>
    <!-- 人群计算---新建人群运算任务弹窗 -->
    <precisionTask
      :taskDialog="dialogPrecisionTask"
      v-if="dialogPrecisionTask"
      @close="closehandleTask"
    />

    <!-- 同步应用 -->
    <SelectSyncApp v-model="isShowSelectApp" :selectSyncArr="delList2" :controlType="controlType" :rowData="rowData" @update="getList"/>

    <!-- 购买sku人群 -->
    <buy-sku-crowd :visible.sync="dialogBuySku" @createSuccess="handleBuySkuSubmit"></buy-sku-crowd>
  </div>
</template>

<script>
import { getSellerInfo } from "@/api/sellerController";
import { getSellercats } from "@/api/analysis/ware-controller";
import { getArea } from "@/api/memberLabel";

import peopleFilter from "@/components/people-filter";
import analysis from "./components/analysis";
import precisionTask from "./components/precision-task";
import myClassify from "./components/classify";

import SetDialog from "@/components/SetDialog";
import inputForm from "./inputFrom/input_form_.vue";
import SelectSyncApp from "./components/SelectSyncApp.vue";
import BuySkuCrowd from './components/BuySkuCrowd.vue'
import {
  getOfficialRecommend,
  getOfficialmemberCrowd,
  officialMarket,
  queryMemberCrowd,
  queryCrowdClassify,
  updateCrowdClassify,
  delCrowdClassify,
  addMemberCrowd,
  createdCount,
  crowdInstance,
  packStatus,
  delMemberCrowd,
  isvUsrPack,
  crowdAnalysis,
  uploadManual,
  uploadImport,
  synDmp,
  updateIsGetCrowd,
  getSeller,
  getSysConfigByKe,
  getTreeData,
  queryOfficialCrowd,
  syncOfficialCrowd
} from "@/api/manage/memberCrowdController";
// 人群运算接口
import {
  getPrecisionCrowdList,
  delPrecisionCrowdTask,
  postPrecisionCrowdTask,
  delPrecisionCrowdMember
} from "@/api/precisionCrowdTask";

import { mapState, mapMutations } from "vuex";
export default {
  components: {
    peopleFilter,
    analysis,
    SetDialog,
    inputForm,
    precisionTask,
    myClassify,
    SelectSyncApp,
    BuySkuCrowd,
  },
  data() {
    return {
      treeData: [],
      classifyIdList: [],
      synchDialog: false,
      shopCategoryVisiv: false,
      // permissionsList: [],
      sysTypeLink: "", //查询系统会员人群
      isCustom: "", //定制人群开关
      isIndustry: "", //行业专属人群开关
      isOpenFlag: "", //定制开关
      isOpenFlagOne: "", //行业开关
      loadingTable: true,
      loadingTableOne: true,
      jumpUrl: "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=myarticle",
      tabIndex: 1,
      officialHeight: document.body.clientHeight - 60 - 40 - 10,
      pageName: "客户营销-客户分群",
      customColors: "#67c23a",
      show: false,
      crowdArray: {},
      isShow: false,
      fileList: [],
      uploadUrl: "",
      generateForm: {
        name: "",
        description: "",
        uploadWay: 0,
        uploadType: 0,
        pins: ""
      },
      dialogGenerate: false,
      synchLoading: false,
      // 首屏显示隐藏控制
      groupingShow: true,
      // 查询条件
      search: {
        searchKey: "",
        classifyIds:"",
        description: "",
        type: "",
        size: 10,
        current: 1
      },
      nowopen1: "",
      outerVisible: false,
      // 系统人群数据
      systemData: [],
      openSystem: false,
      systemDataName: "",
      systemDataDescription: "",
      // 表格数据
      tableData: [],
      total: 0,
      // 表格加载状态控制
      tableLoading: false,
      // 人群分析状态控制
      analysisIsShow: false,
      // 人群筛选状态控制
      peopleFilter: false,
      // 人群编辑存储数据
      editData: null,
      setDialogVisible: false,
      count: "",
      currentdate: "",
      percentage: 0,
      sellerList: [],
      shopMemberType: "",
      initialize: false, // 是否已经初始化
      // 人群类型
      peopleList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "系统人群",
          value: 0
        },
        {
          label: "自定义人群",
          value: 1
        },
        {
          label: "数坊人群",
          value: 7
        },
        {
          label: "上传人群",
          value: 8
        },
        {
          label: "二次营销",
          value: 14
        },
        {
          label: "官方推荐人群",
          value: 9
        },
        {
          label: "行业专属人群",
          value: 10
        },
        {
          label: "定制人群",
          value: 11
        },
        {
          label: "运算人群",
          value: 12
        },
        {
          label: "官方人群",
          value: 15
        },
        // {
        //   label: "互动人群",
        //   value: 13
        // }
      ],
      // 人群类型二级分类
      classPeopleList:[],
      officialList: [],
      officialListitem: [],
      isClick: false, // 防止接口请求前多次点击
      shopCategory: [],
      crowdTaskData: [], // 人群运算列表
      dialogPrecisionTask: false, // 人群运算弹窗
      searchTask: {
        // 运算列表查询
        current: 1,
        size: 10
      },
      searchTaskTotal: 0, // 总数据
      delList: [], // 删除数组
      delLists: [], // 删除数组
      delList2: [], // 删除数组2
      showsss: true,
      allShow: false,
      delTaskDialog: false,
      delMemberDialog: false,
      delMessage: 1,
      classifyForm:{
        id:null,
        type:1,
        name:'',
      },
      classifyVisible:false,
      isOrderHd: false, //京获客资格
      allSearchType:'',
      expandType:null,

      isShowSelectApp: false,
      controlType: 'single',
      rowData: {},
      dialogBuySku: false, // sku购买人群弹窗控制
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      peopleNumState: "peopleNumState"
    }),
    venderId(nVal, oVal) {
      return this.$store.getters.venderId;
    },
    shopInfo() {
      return this.$store.getters.shopInfo;
    },
    permissionsList() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    iconConent() {
      //人群提示
      let content = "";
      if (this.tabIndex == 4) {
        content = "行业人群占用商家自定义创建人群个数，如已关闭可手动开启；";
      } else if (this.tabIndex == 5) {
        content = "定制人群占用商家自定义创建人群个数，如已关闭可手动开启；";
      }
      return content;
    },
    meaasgeClose() {
      let contentOne = "";
      if (this.tabIndex == 4) {
        contentOne = "行业人群获取已关闭，如需获取请手动开启；";
      } else if (this.tabIndex == 5) {
        contentOne = "定制人群获取已关闭，如需获取请手动开启；";
      }
      return contentOne;
    },
    // 0 没有二级分类 1 有二级分类 2 有二级分类且可编辑/删除
    searchCrowdType(){
      if(this.search.type == 1 || this.search.type == 12 || this.search.type == 13){
        return 2
      }else if(this.search.type === "" || this.search.type === 0 || this.search.type == 10 || this.search.type == 11 || this.search.type == 8 || this.search.type == 15){
        return 1
      }else{
        return 0
      }
    },

    getSynData() {
      return (data) => {
        let dmpChannelTypeArr = data.dmpChannelType ? data.dmpChannelType.split(',') : []
        let newArr = []
        dmpChannelTypeArr.forEach(item => {
          if(item == 3) {
            let i = `数坊-${data.lastSynShufangStatus ? '成功':'失败'}`
            newArr.push(i)
          }else if(item == 1) {
            let i = `DMP-${data.lastSynDmpStatus ? '成功':'失败'}`
            newArr.push(i)
          }
        })
        return newArr.join('、')
      }
    }
  },
  watch: {
    initialize(newVal) {
      if (this.$route.query.create && newVal) {
        this.labelCircle();
      }
    },
    dialogGenerate(newVal) {
      if (newVal == false) {
        this.generateForm.name = "";
        this.generateForm.description = "";
        this.generateForm.pins = "";
        this.percentage = 0;
      }
    },
    // from精准营销，自动打开创建人群
    initialize(newVal) {
      if (newVal && this.$route.query.create) {
        this.labelCircle();
      }
    },
    shopInfo(newVal) {
      if (newVal) {
        this.shopMemberType = this.shopInfo.shopMemberType;
        this.getList();
        this.getSystemList();
      }
    }
  },
  created() {
    this.shopMemberType = this.shopInfo.shopMemberType;
    this.getTreeData()
    this.init();
    this.getList();
    this.getSystemList();
    this.getOfficialList();
    getSellerInfo().then(resp => {
      this.editUserInfo(resp && resp.data);
      this.isOpenFlagOne = resp.data.isCustomGet; //定制人群
      this.isOpenFlag = resp.data.isIndustryGet; //行业专属人群
      this.isOrderHd = resp.data.isOrderHd;
      console.log(this.isOpenFlagOne, "-------------------");
    });
    getSellercats().then(res => {
      this.sellerList = res.data;
    });
    // 调用埋点接口
    let fistCate = "客户管理";
    let secondCate = "会员管理";
    let name = "";
    if (this.$route.name == "groupingX") {
      (fistCate = "客户营销"), (secondCate = "精准营销"), (name = "/人群列表");
    } else {
      name = "";
    }
    // console.log(this.$route.name, '============================================');
    // console.log(name, '---------------------------------');
    if (name == "" || name) {
      this.buriedPoint(1, "客户分群" + name, fistCate, secondCate);
    }
  },
  mounted() {
    console.log(this.peopleNumState,'====================');
    console.log("666------>", 666);
    this.dateFormat();
    getSeller().then(res => {
      this.shopCategory = res.data.shopCategory;
      if (res.data.permissions.indexOf("hide:customCrowd") == -1) {
        this.peopleList.splice(7, 1);
      }
      this.getSysConfigByKe();
    });
    var getItem = 1;
  },
  methods: {
    // 更新人群策略
    updateCrowdStrategy() {
      syncOfficialCrowd().then(res=>{
        if(res.code == 1) {
          this.$message.success("更新成功!");
          this.dateFormat();
          this.getOfficialCrowd();
        }else {
          this.$message.error(res.message);
        }
      })
    },
    classifyIdListChange(){
      // 类型为全部-一级限制只能单选
      if(this.search.type === ''){
        if(this.classifyIdList.length){
          // 获取一级类型
          this.classifyIdList = this.classifyIdList.filter(item=>{
            return item[0] == this.expandType
          })
          this.allSearchType = this.classifyIdList[this.classifyIdList.length - 1][0]
          this.search.classifyIds = this.classifyIdList.map(item=>{
            return item[item.length - 1]
          }).join(",")
        }else{
          this.search.classifyIds = ""
          this.search.type = ""
        }
      }else{
        this.search.classifyIds = this.classifyIdList.join(",")
      }
      this.changePage = true
    },
    expandChange(e){
      this.expandType = e[0]
    },
    // 人群运算---查询列表
    onSerach(val) {
      this.showsss = false;
      let param = {
        ...val,
        ...this.searchTask
      };
      this.tableLoading = true;
      getPrecisionCrowdList(param)
        .then(res => {
          console.log(res);
          this.searchTaskTotal = res.data.total;
          this.crowdTaskData = res.data.records;
          this.tableLoading = false;
          this.showsss = true;
        })
        .catch(res => {
          this.tableLoading = false;
          this.showsss = true;
        });
    },
    // 人群运算---新建人群运算任务
    newPrecisionTask() {
      this.dialogPrecisionTask = true;
    },
    // 人群运算---删除任务
    delPrecisionTask(val, row) {
      let theme = "";
      let param = [];
      if (val == 1) {
        // 批量删除
        this.delMessage = 1;
        if (this.delList.length == 0) {
          this.$message.warning(`请选择任务`);
          return;
        }
        this.delLists = this.delList;
      } else {
        // 单个删除
        this.delMessage = 2;
        this.delLists = [row.id];
        // if (row.status == 0) return;
      }
      this.delTaskDialog = true;
    },
    delPrecisionMember(val, row) {
      let theme = "";
      let param = [];
      //批量删除语句2
      console.log("进来这里");
      if (this.delList2.length == 0) {
        this.$message.warning(`你未勾选数据，请勾选后删除`);
        return;
      }
      this.delMemberDialog = true;
    },
    handleDeleteTask() {
      delPrecisionCrowdTask(this.delLists).then(res => {
        console.log(res);
        if (res.code) {
          this.$message.success(`删除成功`);
          this.onSerach();
        } else {
          this.delTaskDialog = false;
          this.$message.success(res.message);
        }
        this.delTaskDialog = false;
      });
    },
    handleDeleteMember() {
      console.log("this.delLists删除人群数组", this.delList2);
      let _delList = [];
      this.delList2.forEach(item => {
        let delItem = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId || "",
          strategyId: item.strategyId || ""
        };
        _delList.push(delItem);
      });
      console.log("删除人群数组", _delList);
      delPrecisionCrowdMember(_delList).then(res => {
        console.log(res);
        if (res.code) {
          this.$message.success(`删除成功`);
          this.getList();
        } else {
          this.delMemberDialog = false;
          this.$message.success(res.message);
        }
        this.delMemberDialog = false;
      });
    },
    closehandleDelete1() {
      this.delTaskDialog = false;
    },
    closehandleDelete2() {
      this.delMemberDialog = false;
    },
    // 人群列表--多选
    handleSelectionChange(val) {
      this.delList = [];
      val.forEach(item => {
        this.delList.push(item.id);
      });
      console.log(this.delList);
    },
    //人群列表-多选2
    handleSelectionChange2(val) {
      this.delList2 = val || [];
      console.log("多选2", this.delList2);
    },
    // 多选禁用状态
    checkboxT(row, index) {
      if (row.status == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    // 多选禁用状态2
    selectable(row, index) {
      if (!row.isAdvanced) {
        if (row.type == 0 || row.type == 10 || row.type == 11) {
          return false;
        } else if (row.type != 0) {
          return true;
        }
      } else {
        return false;
      }
    },
    // 关闭人群运算弹窗
    closehandleTask() {
      this.dialogPrecisionTask = false;
      this.onSerach();
    },
    getSysConfigByKe() {
      getSysConfigByKe({ key: "trade_shop_categroy" }).then(res => {
        const arr = res.data.pvalue.split(",");
        const newArr = this.shopCategory.filter(item =>
          arr.includes(String(item))
        );
        const routeArr = JSON.parse(localStorage.getItem("permissionPath"));
        if (newArr.length > 0 && routeArr.includes("industryCrowd")) {
          this.shopCategoryVisiv = true;
        } else {
          this.peopleList.splice(6, 1);
        }
      });
    },
    // 定制人群开关
    changeSwitchOne(val) {
      let obj = {
        type: this.tabIndex == 5 ? 2 : "",
        isOpen: val
      };
      this.updateIsGetCrowd(obj);
    },
    // 行业开关
    changeSwitch(val) {
      let obj = {
        type: this.tabIndex == 4 ? 1 : "",
        isOpen: val
      };
      this.updateIsGetCrowd(obj);
    },
    //开关
    updateIsGetCrowd(obj) {
      this.officialListitem = [];
      updateIsGetCrowd(obj).then(res => {
        if (res.code == 1) {
          this.$message.success("执行成功!");
          this.getSystemList1(obj.type);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取官方推荐人群
    getOfficialList() {
      getOfficialRecommend().then(res => {
        this.officialList = res.data;
      });
    },
    // 高级版本立即升级
    upgrade() {
      window.open(this.jumpUrl, "_blank");
    },
    // 查看更多
    handleSwitchJump(el) {
      console.log(el,'el');
      var getItem = JSON.parse(localStorage.getItem("crowd"));
      if (!getItem) {
        const jump = (el == "0" && 3) || (el == 1 && 4) || (el == 2 && 5) || "";
        if (this.shopCategoryVisiv) {
          this.tabIndex = jump;
          this.getSystemList1(el);
          return 
        } else if(!this.shopCategoryVisiv && el==0){
           this.getSystemList1(el);
           this.tabIndex = jump;
           return
        }else{
          this.tabIndex = jump+1;
          this.getSystemList1(el+1);
        }
      }
      if (getItem) {
        window.open("/yusms/industryCrowd", "_blank");
      }
    },
    // handleSwitchJump(el) {
    //   var getItem = JSON.parse(localStorage.getItem("crowd"));
    //   console.log(el, "111");
    //   if (!getItem) {
    //     // this.buriedPoint(1, "客户分群/行业专属人群", "客户营销", "精准营销");
    //     this.handleSwitch(3);
    //     console.log("11111--------");
    //     console.log(el, "el");
    //     const jump = (el == "0" && 3) || (el == 1 && 4) || (el == 2 && 5) || "";
    //     if (this.shopCategoryVisiv || shopCategoryVisiv) {
    //       console.log("22222----", el);
    //       this.tabIndex = jump + 1;
    //       this.getSystemList1(el + 1);
    //     } else {
    //       console.log("33333--------");
    //       this.tabIndex = jump;
    //       this.getSystemList1(el);
    //     }
    //   } else if (getItem) {
    //     console.log("4444--------");
    //     if (this.shopCategoryVisiv || shopCategoryVisiv) {
    //       window.open("/yusms/industryCrowd", "_blank");
    //     } else {
    //       this.handleSwitch(3);
    //       const jump =
    //         (el == "0" && 3) || (el == 1 && 4) || (el == 2 && 5) || "";
    //       this.tabIndex = jump;
    //       this.getSystemList1(el);
    //     }
    //   }
    //   // const jump = (el == "0" && 3) || (el == 1 && 4) || (el == 2 && 5) || "";
    //   // if( this.shopCategoryVisiv || shopCategoryVisiv){
    //   //   if (getItem == 0 ) {
    //   //     //关
    //   //       this.tabIndex = jump;
    //   //       this.getSystemList1(el);
    //   //   }else{
    //   //     window.open("/yusms/industryCrowd", "_blank");
    //   //   }
    //   //  }
    // },
    handleSwitch(index) {
      console.log(
        this.$route.name,
        index,
        "============================================"
      );
      // if (this.$route.name == 'grouping') {
      this.buriedPoint(1, "客户分群", "客户营销", "精准营销");
      // } else {
      // 埋点
      let name = "";
      if (index == 3) name = "/系统推荐人群";
      if (index == 2) name = "/官方推荐人群";
      if (index == 4) {
        // name = '/行业专属人群',
        window.open("/yusms/industryCrowd", "_blank");
      }
      this.buriedPoint(1, "客户分群" + name, "客户营销", "精准营销");
      if (index == 5) {
        this.clearBuriedPoint();
        // return
      }
      // }
      if (index != 4) {
        this.tabIndex = index;
      }
      if (index == 1) {
        this.getSystemList();
        if (this.$route.name == "groupingX") {
          this.buriedPoint(1, "客户分群/人群列表", "客户营销", "精准营销");
        }
        return;
      }
      if (index !== 2 && index != 1 && index != 7) {
        const type =
          (index == 1 && "") ||
          (index == 3 && "0") ||
          (index == 4 && 1) ||
          (index == 5 && 2) ||
          "";
        this.getSystemList1(type);
      }
      if(index == 7) {
        this.getOfficialCrowd()
      }
    },
    init() {
      getArea().then(res => {
        if (res.code === 1) {
          let cityArr = [];
          // return
          // 格式化数据
          res.data.forEach(item => {
            // 省份
            item.children.forEach(province => {
              // 城市
              province.children.forEach(city => {
                cityArr.push(city);
              });
              province.children = province.children;
            });
            item.children = item.children;
          });
          // console.log(cityArr);
          if (!sessionStorage.getItem("cityArr")) {
            sessionStorage.setItem("cityArr", JSON.stringify(cityArr));
          }
        }
      });
    },
    format(percentage) {
      return percentage === 100 ? "满" : `${percentage}%`;
    },
    uploadWayChange(val){
      this.generateForm.uploadType = 0
      this.files = null
      this.fileList = []
    },
    downloadTemplate() {
      let url = "",
        fileName = "";
      url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/upload_crowd_pin.txt";
      fileName = "upload_crowd_pin.txt";
      let content = "用户pin1\n用户pin2\n用户pin3\n用户pin4\n用户pin5";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(content)
      );
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // txt订单号模板
    downloadTemplate2() {
      let url = "",
        fileName = "";
      url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/upload_crowd_order.txt";
      fileName = "upload_crowd_order.txt";
      let content = "订单号1\n订单号2\n订单号3";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(content)
      );
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    // excel订单号模板
    downloadTemplate3() {
      let url =  "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E4%B8%8A%E4%BC%A0%E4%BA%BA%E7%BE%A4%E6%8C%89%E8%AE%A2%E5%8D%95%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
    },
    closehandleSc() {
      if (this.percentage < 100 && this.percentage > 0) {
        this.$confirm("文件上传中, 是否关闭弹窗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(() => {
            this.dialogGenerate = false;
          })
          .catch(() => {});
      } else {
        this.dialogGenerate = false;
      }
    },
    //上传人群
    generateCrowd() {
      if (!this.generateForm.name) {
        this.$message.warning("人群名称不能为空");
        return;
      }
      if (!this.generateForm.description) {
        this.$message.warning("人群描述不能为空");
        return;
      }
      if (!this.files && this.generateForm.uploadType == 1) {
        this.$message.warning("未导入文件");
        return;
      }
      if (this.generateForm.uploadType == 0) {
        uploadManual(this.generateForm)
          .then(res => {
            if (res && res.code == 1) {
              this.$message.success(res.message);
              // this.isShow = false;
              this.files = null;
              this.fileList = [];
              this.dialogGenerate = false;
              this.getList();
            } else {
              this.$message.warning(res.message);
            }
          })
          .catch(res => {
            this.$message.error(res.message);
          });
      } else {
        this.isShow = true;
        let formData = new FormData();
        formData.append("file", this.files);
        formData.append("name", this.generateForm.name);
        formData.append("description", this.generateForm.description);
        formData.append("uploadWay", this.generateForm.uploadWay);
        formData.append("uploadType", 1);
        let setInt = setInterval(() => {
          if (this.percentage < 99) {
            this.percentage += 1;
          } else {
            this.percentage = 99;
          }
        }, 100);
        uploadImport(formData)
          .then(res => {
            if (res && res.code == 1) {
              clearInterval(setInt);
              this.percentage = 100;
              this.$message.success(res.message);
              setTimeout(() => {
                this.dialogGenerate = false;
                this.isShow = false;
                this.files = null;
                this.fileList = [];
                this.getList();
              }, 800);
            } else {
              clearInterval(setInt);
              this.percentage = 0;
              this.$message.error(res.message);
            }
          })
          .catch(res => {});
      }
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        // this.process = 100;
        // this.success = false;
        this.$message.warning("上传模板大小不能超过 20MB!");
        return;
      }
      this.files = file;
      // this.isShow = true;
      let titleNew = [{ name: file.name, url: "" }];
      this.fileList = titleNew;
    },
    handleProgress(file) {
      // if(this.dialogGenerate == false){
      //   this.$message.warning("上传中")
      // }
    },
    handleRemove(file, fileList) {
      this.files = null;
      // this.isShow = false;
    },
    //导入上传人群
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-1);
      // let titleNew = [{ name: file.name, url: "" }];
      // this.fileList = titleNew;
      // console.log(this.fileList[0].name,222);
    },
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO"
    }),
    getCreatedCount() {
      createdCount({ venderId: this.venderId }).then(res => {
        this.count = res.data && res.data.count;
      });
    },
    //获得当前时间
    dateFormat() {
      var date = new Date();
      var seperator1 = "-";
      var seperator2 = " ";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        year +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      this.currentdate = currentdate;

      // this.$refs.searchForm.submitForm("formSearch");
    },
    // 获取人群列表
    getList(type) {
      if (type) {
        this.search.current = 1;
      }
      this.tableLoading = true;
      this.getCreatedCount();
      const query = {
        ...this.search
      }
      if(this.search.type === '' && (this.allSearchType || this.allSearchType == 0)){
        query.type = this.allSearchType
      }
      queryMemberCrowd(query).then(res => {
        this.initialize = true;
        var tableData = res && res.data.records;
        this.total = res && +res.data.total;
        this.tableLoading = false;
        var shopMemberType = this.shopMemberType;
        tableData = tableData.filter(item => {
          var flag = true;
          if (shopMemberType == "2" || shopMemberType == "4") {
            // 显示店铺会员，隐藏品牌
            if (
              item.name == "开卡未购会员转化（品牌会员）" ||
              item.name == "未开卡人群入会引导（品牌会员卡）"
            ) {
              flag = false;
            }
          } else if (shopMemberType == "3" || shopMemberType == "5") {
            // 隐藏店铺
            if (
              item.name == "开卡未购会员转化（店铺会员）" ||
              item.name == "未开卡人群入会引导（店铺会员卡）"
            ) {
              flag = false;
            }
          }
          if (flag) {
            return item;
          }
        });

        if (tableData && tableData.length > 0) {
          var sum = 0;
          tableData.forEach(item => {
            sum += item.count;
          });
          if (sum == "0" && this.$store.getters.loginUserInfo.isColdVender) {
            this.$message.warning("人群数据正在推送，请耐心等待哦~");
          }
        }
        this.tableData = tableData;
      });
    },
    // 获取系统人群
    getSystemList(val) {
      const params = { sysType: val ? val : "" };
      this.loadingTable = true;
      this.loadingTableOne = true;
      this.officialListitem = [];
      getOfficialmemberCrowd(params).then(res => {
        if (res.data && res.code == 1) {
          console.log(res, 1987);

          this.loadingTable = false;
          this.loadingTableOne = false;
          if(this.tabIndex == 7) return
          this.systemData = res && res.data[0].list;
          this.systemDataName = res && res.data[0].classifyName;
          this.systemDataDescription = res && res.data[0].classifyDescription;
          this.officialListitem = res.data;
          var shopMemberType = this.shopMemberType;
          //查看更多根据类型跳转到对应的页面
          console.log(res.data[0].type,'res.data[0].type获取系统人群');
          this.sysTypeLink = res.data[0].type;
          console.log(res.data.type, "8523698547");
          if (this.systemData && this.systemData.length > 0) {
            this.systemData.forEach((item, i) => {
              item.isHide = i <= 3 ? true : false;
              // if (shopMemberType == "2" || shopMemberType == "4") {
              //   // 显示店铺会员，隐藏品牌
              //   if (item.name == "开卡未购会员转化（品牌会员）" || item.name == "未开卡人群入会引导（品牌会员卡）") {
              //     item.isHide = true;
              //   }
              // } else if (shopMemberType == "3" || shopMemberType == "5") {
              //   // 隐藏店铺
              //   if (item.name == "开卡未购会员转化（店铺会员）" || item.name == "未开卡人群入会引导（店铺会员卡）") {
              //     item.isHide = true;
              //   }
              // }
            });
          }
          this.officialListitem.forEach(item => {
            item.openSystem = true;
            item.list.forEach((info, i) => {
              if (i <= 3) {
                info.isHide = true;
              } else {
                info.isHide = false;
              }
            });
          });
        }
      });
    },
    // 获取官方人群
    getOfficialCrowd() {
      this.loadingTable = true;
      this.loadingTableOne = true;
      this.officialListitem = [];
      queryOfficialCrowd().then(res => {
        if (res.data && res.code == 1 && this.tabIndex == 7) {
          this.systemData = res && res.data[0].list;
          this.systemDataName = res && res.data[0].classifyName;
          this.systemDataDescription = res && res.data[0].classifyDescription;
          this.officialListitem = res.data;
          //查看更多根据类型跳转到对应的页面
          this.sysTypeLink = res.data[0].type;
          if (this.systemData && this.systemData.length > 0) {
            this.systemData.forEach((item, i) => {
              item.isHide = i <= 3 ? true : false;
            });
          }
          this.officialListitem.forEach(item => {
            item.openSystem = true;
            item.list.forEach((info, i) => {
              if (i <= 3) {
                info.isHide = true;
              } else {
                info.isHide = false;
              }
            });
          });
        }
      }).finally(() => {
        this.loadingTable = false;
        this.loadingTableOne = false;
      });
    },
    // 获取系统人群
    getSystemList1(val) {
      console.log(val,'val++++');
      const params = { sysType: val};
      this.loadingTable = true;
      this.loadingTableOne = true;
      this.officialListitem = [];
      getOfficialmemberCrowd(params).then(res => {
        // 切换到官方人群时不返回值，因为共用一个字段防止出错
        if (res.data && res.code == 1 && this.tabIndex != 7) {
          this.loadingTable = false;
          this.loadingTableOne = false;
          if (this.tabIndex == Number(val) + 3) {
            this.systemData = res && res.data[0].list;
            this.systemDataName = res && res.data[0].classifyName;
            this.systemDataDescription = res && res.data[0].classifyDescription;
            this.officialListitem = res.data;
            var shopMemberType = this.shopMemberType;
            //查看更多根据类型跳转到对应的页面
            console.log(res.data[0].type,'res.data[0].type获取系统人群');
            this.sysTypeLink = res.data[0].type;
            console.log(res.data.type, "8523698547");
            if (this.systemData && this.systemData.length > 0) {
              this.systemData.forEach((item, i) => {
                item.isHide = i <= 3 ? true : false;
              });
            }
            this.officialListitem.forEach(item => {
              item.openSystem = true;
              item.list.forEach((info, i) => {
                if (i <= 3) {
                  info.isHide = true;
                } else {
                  info.isHide = false;
                }
              });
            });
          }
        }
      });
    },
    //展开收起
    handleOpenSystem(index) {
      this.officialListitem = this.officialListitem.map((item, num) => {
        let obj = item;
        if (num === index) {
          obj.openSystem = !item.openSystem;
          obj.list.forEach((info, i) => {
            if (!item.openSystem) {
              info.isHide = true;
            } else {
              info.isHide = i <= 3 ? true : false;
            }
          });
        }
        return obj;
      });
    },
    // 点击人群分析
    handleAnalysis(value) {
      this.groupingShow = false;
      this.analysisIsShow = true;
      this.show = true;
      this.crowdArray = value;
    },
    // 同步数坊人群
    handleSynch() {
      this.synchLoading = true;
      this.synchDialog = false;
      this.$message.warning("人群数据正在推送，请耐心等待哦~");
      isvUsrPack().then(res => {
        if (res.code == "1") {
          this.synchLoading = false;
        } else {
          this.synchLoading = false;
          this.$message.error(res.message);
        }
      });
    },
    // 标签圈人
    labelCircle() {
      if (!this.initialize) {
        this.$message.warning("请先完成初始化！");
        return;
      }
      let num = this.peopleNumState
      // if(this.peopleNumState) num = 500
      if (this.count >= num) {
        this.$message.warning(
          "自定义人群数量已达到上限，请删除人群后再创建哦~"
        );
        return;
      }
      let routeUrl = this.$router.resolve({
        name: "peopleFilter",
      });
      window.open(routeUrl.href, "_blank");

      // this.groupingShow = false;
      // this.peopleFilter = true;
    },
    // 点击编辑
    handleEdit(data) {
      if (data.type != 1 && data.type != 13) {
        this.$message.warning("非自定义人群不可编辑");
        return;
      }
      if(data.type == 13 && !this.isOrderHd){
        let flag = false
        JSON.parse(data.strategy).forEach(item=>{
          if(item.tagname != "uinte_open_card" && item.tagname != "unite_get_coupon"){
            flag = true
          }
        })
        if(flag) return this.$message.warning("使用互动标签需订购京获客，请订购后使用该标签~");
      }
      this.editData = data;
      let routeUrl = this.$router.resolve({
        name: "peopleFilter",
        query: {
          id:data.precisionCrowdStrategyId
        },
      });
      window.open(routeUrl.href, "_blank");
      // this.groupingShow = false;
      // this.peopleFilter = true;
    },
    // 复制
    handleCopy(data) {
      if (data.type != 1 && data.type != 13) {
        this.$message.warning("非自定义人群不可编辑");
        return;
      }
      if(data.type == 13 && !this.isOrderHd){
        let flag = false
        JSON.parse(data.strategy).forEach(item=>{
          if(item.tagname != "uinte_open_card" && item.tagname != "unite_get_coupon"){
            flag = true
          }
        })
        if(flag) return this.$message.warning("使用互动标签需订购京获客，请订购后使用该标签~");
      }
      this.editData = data;
      let routeUrl = this.$router.resolve({
        name: "peopleFilter",
        query: {
          id:data.precisionCrowdStrategyId,
          type:2,
        },
      });
      window.open(routeUrl.href, "_blank");
      // this.groupingShow = false;
      // this.peopleFilter = true;
    },
    // 同步数坊/DMP
    handleSynDMP(row) {
      this.$refs.focus.focus(); // 防止滑动的样式再次显示
      if(row.count <=0) {
        this.$alert('所选人群的人群数量为0，请重新选择', '提示', {
          confirmButtonText: '确定',
          callback: action => {
           }
        });
        return
      }
      this.isShowSelectApp = true;
      this.controlType = 'single';
      this.rowData = { ...row }

      return

      this.$confirm("是否确定同步？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        var param = {
          precisionCrowdStrategyId: row.precisionCrowdStrategyId
        };
        if (row.strategyId) {
          param.strategyId = row.strategyId;
        } else {
          param.searchId = row.searchId;
        }

        synDmp(param).then(res => {
          if (res.code == "1") {
            if (res.data.code == "1") {
              this.$message.success("申请DMP任务已提交成功");
            } else {
              this.$message.error(res.message);
            }
            this.getList();
          }
        });
      });
    },

    handleDelete1(nowopen) {
      this.nowopen1 = nowopen;
      this.outerVisible = true;
    },
    //关闭删除弹框
    closehandleDelete() {
      this.outerVisible = false;
      this.$message.warning("已关闭删除");
    },
    handleDeleteTable() {
      this.handleDelete(this.nowopen1);
    },
    // 点击删除
    handleDelete({ type, strategyId, precisionCrowdStrategyId }) {
      if (type == 0) {
        this.$message.warning("非自定义人群不可删除");
        return;
      }
      // this.$confirm("确定要删除吗?", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      // })
      // .then(() => {
      delMemberCrowd(precisionCrowdStrategyId, strategyId)
        .then(res => {
          if (res && res.code == 1) {
            this.outerVisible = false;
            this.$message.success("删除成功!");
            this.getList();
            this.getSystemList();
          }
          // })
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 人群筛选隐藏
    onCancel(state) {
      if (this.editData) this.editData = null;
      this.peopleFilter = false;
      this.groupingShow = true;
      if (state) {
        this.getList();
        this.getSystemList();
      }
    },
    // 人群分析隐藏
    analysisBack() {
      this.analysisIsShow = false;
      this.groupingShow = true;
    },
    // 分页信息变化
    handleSizeChange(val) {
      this.search.current = 1;
      this.search.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.current = val;
      this.getList();
    },
    // 点击营销跳转营销页面
    goToMarketing(item) {
      window.localStorage.setItem("strategy", JSON.stringify(item));

      // return
      let routeUrl = this.$router.resolve({
        path: "/marketing/marketing/accurate_market",
        query: { to: "grouping" }
      });
      window.open(routeUrl.href, "_blank");
    },
    // 官方推荐人群-立即营销
    handleOfficalMarket(item) {
      if (this.isClick) {
        return;
      }
      var level = item.strategyRecLevel;
      var param = {
        level
      };
      this.isClick = true;
      officialMarket(param).then(res => {
        this.isClick = false;
        if (res.code == "1") {
          this.goToMarketing(res.data);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    reset() {
      
      this.search.searchKey = "";
      this.search.classifyIds = "";
      this.classifyIdList = []
      this.search.description = "";
      this.search.type = "";
      this.allSearchType = ""
      this.search.size = 10;
      this.search.current = 1;
      this.getAllTypeList()
      this.getList();
    },
    // 获取分类树
    getTreeData(){
      getTreeData().then(res => {
        this.treeData = res.data
        this.handleChangeType()
      })
    },
    // 切换一级分类
    handleTypeClick(val) {
      this.search.type = val
      this.changePage = true
      // 切换分类-重置分类选中值
      this.classifyIdList = []
      this.handleChangeType()
    },
    // 更改一级分类时查询二级分类
    handleChangeType(){
      this.search.classifyIds = ''
      // 如果一级分类为全部
      if(this.search.type === ''){
        this.getAllTypeList()
      }else{
        if (this.searchCrowdType) {
          this.treeData[0].children.forEach(item => {
            if(item.type == this.search.type){
              this.classPeopleList = item.children
            }
          })
        }
      }
    },
    // 获取全部的分类
    getAllTypeList(){
      const listAll = []
      const types = [7,9,14] // 没有二级分类
      this.peopleList.forEach(list=>{
        this.treeData[0].children.forEach(item=>{
          if(list.value === item.type){
            const obj =  {...item,name:list.label}
            if(types.includes(item.type)){
              obj.children = [{
                id:"",
                name:"全部"
              }]
            }
            listAll.push(obj)
          }
        })
      })
      this.classPeopleList = listAll
    },
    // 点击创建分类
    handleCreateClassify(){
      this.classifyForm.id = null,
      this.classifyForm.type = 1,
      this.classifyForm.name='',
      this.classifyVisible = true;
    },
    // 点击编辑分类
    handleEditClassify(row){
      this.classifyForm.id = row.classifyId,
      this.classifyForm.type = row.type,
      this.classifyForm.name= row.name,
      this.classifyVisible = true;
    },
    // 保存分类
    saveClassify(){
      if(!this.classifyForm.name){
        this.$message.warning("请填写分类名称");
        return
      }
      updateCrowdClassify(this.classifyForm).then(res=>{
        if(res.code == 1){
          let message = this.classifyForm.id ? '修改成功！': '创建成功！'
          this.$message.success(message);
          this.classifyVisible = false;
          this.handleChangeType();
        }else{
          this.$message.error(res.message);
        }
        
      })
    },
    deleteClassify(row){
      let message = "<i class='el-icon-warning' style='color:#FD4D45;margin-right:8px;vertical-align: top;margin-top:5px'></i>"+
      "<div style='display:inline-block'>该分类下有"+row.num+"个人群，该分类下的人群也会删除<br />是否确定删除？</div>"
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        dangerouslyUseHTMLString:true,
        customClass:"tip"
        }
      ).then(() => {
        delCrowdClassify(row.classifyId).then(res=>{
          if(res.code == 1){
            this.$message.success("删除成功!");
            this.handleChangeType();
          }else{
            this.$message.error(res.message);
          }
          
        })
      })
      
    },
    handleBuySkuSubmit(data) {
      this.dialogBuySku = false
      this.$message.success('购买sku人群创建成功')
      this.getList();
    },
  }
};
</script>

<style lang="scss">
.all-classify{
  .el-cascader-panel {
    .el-scrollbar:first-child {
      .el-checkbox {
        display: none;
      }
    }
  }
  .el-cascader-menu__wrap{
    overflow-x: hidden;
  }
}
</style>

<style lang="scss" scoped>
// .systems::after {
//   content: "";
//   position: absolute;
//   left: 5px;
//   border-left: 4px solid #fe4d45;
//   margin-right: 4px;
//   border-radius: 3px;
// }
.imgpath {
  max-height: 33px;
  position: absolute;
  right: 0;
  top: -1px;
}

.classifyName {
  display: block;
  position: relative;
  font-size: 14px;
  padding: 10px 10px 10px 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fafafa;
  margin-top: 15px;
  color: #333;
  min-height: 40px;

  &::after {
    content: "";
    position: absolute;
    left: 6px;
    display: block;
    background: #fe4d45;
    height: 14px;
    width: 3px;
    border-radius: 3px;
    top: 15px;
  }

  .open {
    color: #fe4d45;
    font-size: 14px;
    cursor: pointer;
  }
}

.tab-line {
  font-size: 14px;
  color: #666666;
  border-bottom: 1px solid #dddddd;
  margin: 24px 28px 0 28px;

  .tab-item {
    // padding: 15px 0;
    text-align: center;
    width: 106px;
    height: 36px;
    line-height: 36px;
    display: inline-block;
    position: relative;
    cursor: pointer;
    margin-right: 2px;
    border: 1px solid #dddddd;
    border-bottom: none;

    span {
      position: absolute;
      width: 100%;
      left: 50%;
      height: 2px;
      transform: translateX(-50%);
      bottom: -2px;
      display: none;
    }

    &.active {
      border-top: 2px;

      span {
        display: block;
        background: #fff;
      }
    }
  }
}
/deep/.el-table th.el-table__cell > .cell {
  padding: 0 10px 0 14px;
}

.grouping-container {
  min-width: 1080px;
  box-sizing: border-box;
  padding: 10px 20px 20px;

  &.official {
    padding-bottom: 12px;
    min-height: 500px;

    .head {
      height: 100%;
    }
  }

  .no-goods {
    text-align: center;
    color: #333;
    font-size: 14px;
    // padding-top: 105px;
  }

  button {
    outline: none;
    border-radius: 3px;
    transition: all 0.2s;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    border: none;
    cursor: pointer;
  }

  .buttonBox {
    .b1 {
      width: 98px;
      height: 32px;
      color: #666666;
      // position: absolute;
      border-radius: 3px;
      margin-top: 20px;
      border: 1px solid #dddddd;
      background-color: #fff;

      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }

    .b2 {
      width: 98px;
      // position: absolute;
      // margin-right: 80px;
      height: 32px;
      margin: 20px 80px 10px 10px;
      border: 1px solid #fe4d45;
      color: #ffffff;
      border-radius: 3px;
      background-color: #fe4d45;

      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }

      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }

  .systemDesc {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    margin-top: 20px;
    padding: 7px 12px;
    // background: rgba(250, 250, 250, 1);
    font-size: 14px;
    font-weight: 400;
    color: #333;
    background-color: #fafafa;

    p {
      display: flex;
      align-items: center;
      margin: 0;

      .system {
        display: inline-block;
        font-size: 14px;
        font-weight: 500;

        &::before {
          content: "";
          border-left: 4px solid #fe4d45;
          margin-right: 4px;
          border-radius: 3px;
        }
      }

      .update {
        margin-left: 8px;
      }
    }

    .open {
      color: #fe4d45;
      cursor: pointer;
    }
  }

  .head {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    min-height: 200px;

    h4 {
      box-sizing: border-box;
      margin: 0;
      padding-left: 28px;
      height: 54px;
      line-height: 53px;
      border-bottom: 1px solid #f0f0f0;
      color: #2e3458;
      font-size: 16px;
      font-weight: bold;
    }

    .head-cnt {
      box-sizing: border-box;
      padding: 20px 28px 10px;

      .tips {
        display: flex;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 12px 12px 8px;
        background: rgba(250, 250, 250, 1);
        border-radius: 3px;
        font-size: 14px;
        font-weight: 400;
        color: #333;

        i {
          color: #fe8f8a;
        }

        .area {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          p {
            margin: 8px 0;
          }

          .set {
            margin-left: 20px;

            color: #7f85e9;
            cursor: pointer;

            &:hover {
              color: #fe4d45;
            }
          }
        }
      }

      .tempList {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 20px;
        // max-height: 200px;
        overflow: hidden;
        transition: all 0.4s linear;

        .item-box {
          width: 25%;
          padding: 0 8px;

          @media screen and (max-width: 1540px) {
            padding: 0 6px;
          }

          margin-bottom: 20px;

          .item {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            box-sizing: border-box;
            position: relative;
            padding: 16px 32px;

            @media screen and (max-width: 1760px) {
              padding: 16px 14px 10px 14px;
            }

            @media screen and (max-width: 1540px) {
              padding: 16px 10px 16px 10px;
            }

            min-height: 180px;
            border: 1px solid rgba(238, 238, 238, 1);
            border-radius: 4px;

            .headName {
              display: flex;
              align-items: center;

              .wrap-name {
                img {
                  position: relative;
                  top: -5px;
                  left: 2px;
                }
              }

              .i {
                width: 46px;
                height: 46px;
                margin-right: 16px;
                // background: linear-gradient(
                //   321deg,
                //   rgba(254, 203, 144, 1) 0%,
                //   rgba(255, 232, 206, 1) 100%
                // );
                border-radius: 50%;
                opacity: 1;
              }

              .name {
                color: #333;
                font-size: 16px;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .desc {
              color: #666;
              font-size: 14px;
              font-weight: 400;
              line-height: 24px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;

              @media screen and (max-width: 1760px) {
                margin-top: 16px;
              }
            }

            .footBtn {
              display: flex;
              align-items: flex-end;
              justify-content: space-between;

              @media screen and (max-width: 1760px) {
                padding-top: 10px;
              }

              @media screen and (max-width: 1540px) {
                padding-top: 10px;
              }

              p {
                color: #fe4d45;
                font-size: 24px;

                @media screen and (max-width: 1760px) {
                  font-size: 22px;
                }

                @media screen and (max-width: 1540px) {
                  font-size: 20px;
                }

                font-weight: 500;

                span {
                  color: #999;
                  font-size: 14px;
                  font-weight: 400;
                }
              }

              .btns {
                text-align: center;

                @media screen and (max-width: 1740px) {
                  width: 90px;
                  // height: 28px;
                }

                .renqun_button1 {
                  width: 98px;
                  height: 32px;
                  color: #666666;
                  border: 1px solid #dddddd;
                  background-color: #fff;
                }

                .renqun_button1:hover {
                  color: #fe4d45;
                  border: 1px solid #fe4d45;
                  background-color: #fff4f4;
                }

                .yinxiao_button2 {
                  width: 92px;
                  height: 30px;
                  margin-top: 10px;

                  @media screen and (max-width: 1760px) {
                    width: 90px;
                    height: 30px;
                    margin: 6px 0 0 0 !important;
                  }

                  @media screen and (max-width: 1540px) {
                    width: 84px;
                    height: 28px;
                    margin: 6px 0 0 0 !important;
                  }

                  color: #fe4d45;
                  border: 1px solid #fe4d45;
                  background-color: #fff;
                }

                .yinxiao_button3 {
                  width: 98px;
                  height: 32px;

                  @media screen and (max-width: 1760px) {
                    width: 90px;
                    height: 30px;
                    margin: 6px 0 0 0 !important;
                  }

                  @media screen and (max-width: 1540px) {
                    width: 84px;
                    height: 28px;
                    margin: 6px 0 0 0 !important;
                  }

                  margin-top: 10px;
                  color: rgb(221, 221, 221);
                  border: 1px solid rgb(221, 221, 221);
                  background-color: #fff;
                }

                .yinxiao_button4 {
                  width: 98px;
                  height: 32px;

                  @media screen and (max-width: 1760px) {
                    width: 90px;
                    height: 30px;
                    margin: 6px 0 0 0 !important;
                  }

                  @media screen and (max-width: 1540px) {
                    width: 84px;
                    height: 28px;
                    margin: 6px 0 0 0 !important;
                  }

                  margin-top: 10px;
                  color: #999;
                  border: 1px solid #ccc;
                  background-color: #fff;
                }

                .yinxiao_button4:hover {
                  border-color: #fe4d45;
                  color: #fe4d45;
                  background-color: #fff6f6;
                }

                .yinxiao_button2:hover {
                  color: #ffffff;
                  background-color: #fe4d45;
                }

                .yinxiao_button3:hover {
                  border: 1px solid rgb(221, 221, 221);
                }
              }
            }
          }

          &:nth-child(4n + 1) {
            padding: 0 8px 0 0;

            @media screen and (max-width: 1540px) {
              padding: 0 6px 0 0;
            }
          }

          &:nth-child(4n) {
            padding: 0 0 0 8px;

            @media screen and (max-width: 1540px) {
              padding: 0 0 0 6px;
            }
          }

          p {
            margin: 0;
          }
        }

        &.check {
          max-height: 100%;
        }
      }
    }
  }

  .footTable {
    box-sizing: border-box;
    padding: 20px 28px 30px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;

    .search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 20px 0;

      button {
        margin-top: 10px;
        // width: 98px;
        height: 32px;
        padding: 0 12px;
        line-height: 28px;
        margin-right: 8px;
        background-color: #fe4d45;
        vertical-align: middle;
        color: #fff;
      }

      .biaoqian_button:hover {
        opacity: 0.9;
        background-color: #fe4d45;
      }

      .biaoqian_button1 {
        // width: 98px;
        height: 32px;
        color: #fe4d45;
        border-radius: 3px;
        border: 1px solid #fe4d45;
        background-color: #fff;

        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }

        &:active {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }

      .biaoqian_button2 {
        width: 98px;
        height: 32px;
        color: #666666;
        border-radius: 3px;
        border: 1px solid #dddddd;
        background-color: #fff;

        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }

        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }

      span {
        color: #7f85e9;
        font-size: 14px;
        font-weight: 400;
      }

      .right {
        display: flex;
        align-items: center;

        .line {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          margin-right: 25px;

          span {
            margin-right: 4px;
            color: #333;
            white-space: nowrap;
          }
        }

        .btn {
          display: flex;
          margin-top: -10px;
          align-items: center;

          button {
            transition: all 0.3s;

            &:first-child {
              margin-left: 20px;
              color: #fe4d45;
              border: 1px solid #fe4d45;
              background-color: #fff;

              &:hover {
                background-color: #fe4d45;
                color: #fff;
              }
            }

            &:last-child {
              color: #666;
              border: 1px solid #ddd;
              background-color: #fff;

              &:hover {
                color: #fe4d45;
                background-color: #fff4f4;
                border: 1px solid #fe4d45;
              }
            }
          }
        }
      }
    }

    .operation-btn {
      .titleColorB {
        margin-left: 10px;
        color: #ddd;
        cursor: not-allowed;
      }

      .titleColorR {
        cursor: pointer;
        color: #7f85e9;
        margin-left: 10px;

        &:hover {
          color: #fe4d45;
        }
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .tips {
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 12px 12px 8px;
    background: #fff9f9;
    border-radius: 3px;
    font-size: 14px;
    // font-weight: 400;
    color: #333;
    margin-top: 10px;

    i {
      color: #fe8f8a;
    }

    .area {
      display: flex;
      flex-direction: column;
      margin-left: 10px;

      .set {
        margin-left: 20px;

        color: #7f85e9;
        cursor: pointer;

        &:hover {
          color: #fe4d45;
        }
      }
    }
  }
}
.scene {
  margin-top: 16px;
  >div {
    display: inline-block;
  }

  .scene_label {
    width: 60px;
    text-align: right;
    margin-right: 12px;
  }

  .scene_ul {
    padding-left: 5px;

    .scene_li {
      display: inline-block;
      background: #F5F7FA;
      color: #666666;
      font-weight: 400;
      font-size: 14px;
      border-radius: 4px;
      padding: 2px 8px;
      margin-right: 8px;
      line-height: 24px;
      cursor: pointer;
      transition: all .1s linear;
    }

    .scene_li_check {
      background: #fff4f4;
      color: #fe4d45;
    }
  }
}
</style>
